<template>
  <div id="dailyReports" class="margin-subpages">
    <div class="fs-18 fw-700">{{ $t("reports.DAILY_REPORT_PREVIEW") }}</div>
    <div class="line-section"></div>
    <div class="flex-center">
      <div class="mr-16">
        <el-cascader
          v-model="managerSelected"
          :placeholder="$t('reports.Select_a_Manager')"
          :options="managerList"
          :filter-method="filterManagerFunction"
          filterable
          clearable
        >
          <template slot-scope="{ node, data }">
            <span class="fs-14">{{ data.firstname }} {{ data.lastname }}</span>
          </template>
        </el-cascader>
      </div>
      <div>
        <el-date-picker
          v-model="dateSelected"
          type="date"
          format="ddd, MMMM d, yyyy"
          value-format="yyyy-MM-dd"
          style="widht: 320px"
          :placeholder="$t('reports.Select_date')"
          ref="datepicker_daily"
          :picker-options="pickerOptions"
          placement="bottom-start"
        >
        </el-date-picker>
      </div>
      <div class="pl-20" v-if="this.inforDailyData && this.inforDailyData.file">
        <svg
          @click="exportReport()"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
      </div>
    </div>
    <div class="flex-center fs-16 mt-32">
      <div class="flex-center">
        <span class="fw-700 mr-16">{{ $t("reports.Delivery_Status") }}:</span>
        <div
          v-if="inforDailyData.deliveryStatus === 'none'"
          class="flex-center"
          style="width: 150px"
        >
          <div class="status status-gray"></div>
          <div
            class="text-pending mr-2"
            style="width: 90px; height: 16px"
          ></div>
        </div>
        <div
          v-else-if="inforDailyData.deliveryStatus === 'undelivered'"
          class="flex-center"
          style="width: 150px"
        >
          <div class="status status-red"></div>
          {{ $t("reports.Undelivered") }}
        </div>
        <div
          v-else-if="inforDailyData.deliveryStatus === 'delivered'"
          class="flex-center"
          style="width: 150px"
        >
          <div class="status status-green"></div>
          {{ $t("reports.Delivered") }}
        </div>
        <div v-else class="flex-center" style="width: 150px">
          <div class="status status-gray"></div>
          <div
            class="text-pending mr-2"
            style="width: 90px; height: 16px"
          ></div>
        </div>
      </div>
      <div class="flex-center">
        <div v-if="inforDailyData.deliveryStatus === 'undelivered'">
          <span class="fw-700 mr-16">{{ $t("reports.Issue") }}:</span>
          <span style="width: 150px">{{ inforDailyData.issue }}</span>
        </div>
        <div v-else-if="inforDailyData.deliveryStatus === 'delivered'" class="flex-center">
          <span class="fw-700 mr-16">{{ $t("reports.Read_Status") }}:</span>
          <div v-if="inforDailyData.readStatus" class="status status-green mr-8"></div>
          <div v-else class="status status-red mr-8"></div>
          <span>{{ inforDailyData.readStatus }}</span>
        </div>
      </div>
    </div>
    <div v-if="blurMode"
      :class="['demomode-warning', 'flex-between']">
      <div>{{ $t("demomode.warning") }}</div>
    </div>
    <div
      class="mock-email"
      v-if="managerSelected && dateSelected && inforDailyData.preview"
    >
      <div class="body-email center">
        <!-- <link rel="inforDailyData.preview" href="styles.css" /> -->
        <div v-html="inforDailyData.preview"></div>
      </div>
    </div>
    <!-- <div class="mock-email" v-if="managerSelected && dateSelected && inforDailyData.preview">
      <div class="body-email center fs-20 pt-40 pb-40" style="padding-top: 60px;">
        <div>
          Your daily team insights for
          <span class="fw-700">{{ inforDailyData.data }}</span>
        </div>
        <div>{{ inforDailyData.teamName }}</div>
      </div>
      <div class="body-email happiness center pb-20">
        <div class="flex-mid fs-24 focus-day pt-40 pb-10 fc-FFFFFF fw-700">
          <img
              :src="getImgUrl('Happiness')"
              class="pr-20"
              style="width: 52px; height: 52px; border-radius: 52px;"
            />
          Happiness
        </div>
        <div class="fc-3B3B3B fs-24">
          Your team is 
          <span class="fw-700">{{ happinessData.feeling }}</span>
        </div>
        <div class="fc-3B3B3B fs-14 mt-10 mb-20">
          {{ happinessData.badResponded }} out of
          {{ happinessData.directReport }} responded that they were “Not great”
          or worse
        </div>
        <div class="feeling-status fs-14 fc-FFFFFF">
          <div class="fc-FFFFFF fw-700 mb-8">OVERVIEW BY TEAM</div>
          <div class="grid-2-50" style="grid-template-columns: auto 160px">
            <div
              class="focus-team fw-700 right flex-center ml-auto pr-38 pl-22"
              style="border-radius: 24px 0 0 24px"
            >
              My Direct Reports
            </div>
            <div
              class="focus-team flex-center pr-4"
              style="border-radius: 0 24px 24px 0"
            >
              <div
                :class="`status status-${directStatus} m-3`"
                v-for="(directStatus, index) in happinessData.weeklyStatus"
                :key="index + '_team_feeling_' + directStatus"
              ></div>
            </div>
          </div>
          <div
            class="grid-2-50"
            style="grid-template-columns: auto 160px"
            v-for="value in happinessData.teamData"
            :key="'team_' + value.teamName"
          >
            <div class="right flex-center ml-auto pr-38">
              {{ value.teamName }}
            </div>
            <div class="flex-center pr-4 my-5">
              <div
                :class="`status status-${status} mx-3`"
                v-for="(status, index) in value.weeklyStatus"
                :key="'status_' + index + status"
              ></div>
            </div>
          </div>
          <div class="grid-2-50" style="grid-template-columns: auto 160px">
            <div></div>
            <div class="flex-center">
              <div
                :class="`day-label ${
                  happinessData.toDayIs == 'M' ? 'focus-day' : ''
                }`"
              >
                M
              </div>
              <div
                :class="`day-label ${
                  happinessData.toDayIs == 'T' ? 'focus-day' : ''
                }`"
              >
                T
              </div>
              <div
                :class="`day-label ${
                  happinessData.toDayIs == 'W' ? 'focus-day' : ''
                }`"
              >
                W
              </div>
              <div
                :class="`day-label ${
                  happinessData.toDayIs == 'Th' ? 'focus-day' : ''
                }`"
              >
                Th
              </div>
              <div
                :class="`day-label ${
                  happinessData.toDayIs == 'F' ? 'focus-day' : ''
                }`"
              >
                F
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body-email card center pb-40">
        <div v-for="(data, index) in cardData" :key="'question_card_' + index" class="question-card">
          <div class="flex-mid fs-24 focus-day pt-40 pb-16 fc-FFFFFF fw-700">
             <img
              :src="getImgUrl(data.topic)"
              class="pr-20"
              style="width: 52px; height: 52px; border-radius: 52px;"
            />
            {{ data.topic }}
          </div>
          <div class="fs-14 fc-FFFFFF opa-08 mb-30">Summary of insights from your direct reports</div>
          <div class="card-top">
            {{ data.title }}
          </div>
          <div class="card-bottom fc-3B3B3B">
            <div class="fs-24 fw-900 pt-18">{{ data.percent }}%</div>
            <div class="fs-12">{{ data.result }}</div>
            <div class="fs-12 py-12 fc-B7B7B7">of {{ data.directReport }} direct reports</div>
            <div class="fs-14 flex-mid">
                <div :class="`fs-12 mr-8 mb-2 status-point ${data.responded > 40 ? 'yellow' : data.responded > 80 ? 'green' : 'red'}`"></div>
              <div class="fw-900">{{ data.responded }}% </div>
              <div>of {{ data.overall }} overall</div>
               
            </div>
          </div>
          <div v-if="data.topic == 'Personal Growth'" class="mt-20 mx-auto pb-10" style="width: 640px;">
            <div class="fc-FFFFFF fs-20 fw-700">{{ data.question }}</div>
              <div class="fc-FFFFFF fs-14 mt-10 mb-22 opa-03">สรุปคำตอบจากทีมของคุณ</div>
            <div class="fc-FFFFFF fs-14">"{{ data.answer }}" -{{ data.user }}</div>
          </div>
        </div>
      </div>
      <div class="body-email center footer">
        <div>Need help reading these insights?</div>
        <div>Check out this quick guide</div>
      </div>
    </div> -->
    <div v-else class="center fc-A0A0A0 fs-24 preview-reports mt-32">
      <div v-if="!managerSelected || !dateSelected" style="padding-top: 80px">
        <div class="fs-16 fw-700 fc-000000 opa-04">
          {{ $t("reports.Preview_a_report_by") }} <br />
          {{ $t("reports.from_the_above_menu") }}
        </div>
      </div>
      <div v-else-if="loadingDailyReportStatus" style="padding-top: 80px">
        <i class="el-icon-loading"></i>
        <div class="fs-16">{{ $t("reports.Loading") }}...</div>
      </div>
      <div
        style="padding-top: 80px"
        v-else-if="!loadingDailyReportStatus && !inforDailyData.preview"
      >
        <div class="fs-16">
          {{ $t("reports.Unable_to_preview_this") }}
        </div>
      </div>
    </div>
    <download-progress :active="showSnackbar"></download-progress>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'
import axios from 'axios'
export default {
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  created() {
    this.$store.dispatch("reportPreview/getOrganization1level", this.user).then(()=>{
      this.$store.dispatch("reportPreview/getManagerOption", this.user)
    });
    // this.$store.dispatch("reportPreview/getManagerOption", this.user);
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    managerList() {
      return this.$store.getters["reportPreview/managerList"];
    },
    inforDailyData() {
      return this.$store.getters["reportPreview/inforDailyData"];
    },
    loadingDailyReportStatus() {
      return this.$store.getters["reportPreview/loadingDailyReportStatus"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  watch: {
    dateSelected() {
      this.getDataToPreview();
    },
    managerSelected() {
      this.getDataToPreview();
    },
  },
  data() {
    return {
      firstTimeloading: true,
      none: undefined,
      showSnackbar: false,
      // inforDailyData: {
      //   data: "Tuesday, July 20, 2021",
      //   teamName: "Happily / Tech",
      //   deliveryStatus: "delivered", // Type : "none", "undelivered", "delivered"
      //   issue: "Hard Bounced", // "-"
      //   readStatus: "Opened by John Smith on July 2, 2021 at 9:34 AM", // "-"
      // },
      managerSelected: "",
      // managerList: [
      //   {
      //     value: "id164asasdf13264",
      //     label: "Adison Riewthong",
      //   },
      //   {
      //     value: "id13564asd613264",
      //     label: "Chanitra Suthamma",
      //   },
      //   {
      //     value: "id112564614s3264",
      //     label: "Ittigorn Tradussadee",
      //   },
      //   {
      //     value: "id13561261f3264",
      //     label: "Kantamad Luemon",
      //   },
      // ],
      dateSelected: "",
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
    };
  },
  methods: {
    disabledDate(date) {
      return new Date() < date || date < new Date("2021-08-31") || new Date(date).getDay() == 0 || new Date(date).getDay() == 1;
    },
    getDataToPreview() {
      if (this.managerSelected[0] && this.dateSelected) {
        this.firstTimeloading = false;
        this.$store.dispatch("reportPreview/getDataPreview", {
          user: this.managerSelected[0],
          date: this.dateSelected,
          type: "report_daily_boss",
          loading: "Daily",
        });
      }
    },
    filterManagerFunction(node, keyword) {
      let keywordArr = keyword.split(" ");
      if (keywordArr.length > 1) {
        for (let i = 0; i < keywordArr.length; i++) {
          if (
            node.data.firstname
              .toLowerCase()
              .indexOf(keywordArr[i].toLowerCase()) === 0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (
            node.data.lastname
              .toLowerCase()
              .indexOf(keywordArr[i].toLowerCase()) === 0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          }
        }
      } else {
        return (
          node
            .getText(false, null)
            .toLowerCase()
            .indexOf(keyword.toLowerCase()) >= 0
        );
      }
    },
    async exportReport() {
      let file = ''
      file = this.inforDailyData.file
      if(file && !this.showSnackbar){
        this.showSnackbar = true
        axios({
          method: "get",
          url: file
        })
          .then(result => {
            let body = document.body
            let html = document.documentElement
            let height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
            let heightCM = height / 35.35
            let resultData = result.data
            /* REPLACE URL FROM s3 to firebase */
            const regex = /[(http(s)?):\/\/(www\.)?-a-zA-Z0-9@:%.\+#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%\+.#?&//=]*)/ig
            const found = resultData.match(regex)
            for(const x in found){
              const sp = found[x].split('connected-pub.s3.ap-southeast-1.amazonaws.com/happily/')
              if(sp.length > 1){
                let name = sp[1]
                name = name.replace(/\//g, '%2F')
                let text = `https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Freport_images%2F${name}?alt=media`
                resultData = resultData.replace(found[x],text)
              }
              const sp2 = found[x].split('s3-ap-southeast-1.amazonaws.com/connected-pub/happily/')
              if(sp2.length > 1){
                let name2 = sp2[1]
                name2 = name2.replace(/\//g, '%2F')
                let text2 = `https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Freport_images%2F${name2}?alt=media`
                resultData = resultData.replace(found[x],text2)
              }
              const sp3 = found[x].split('connected-pub.s3-ap-southeast-1.amazonaws.com/happily/')
              if(sp3.length > 1){
                let name3 = sp3[1]
                name3 = name3.replace(/\//g, '%2F')
                let text3 = `https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Freport_images%2F${name3}?alt=media`
                resultData = resultData.replace(found[x],text3)
              }
            }
            /* REPLACE NAMES OF FEEDBACK GIVERS */
            const regex_name = /style="font-size: 16px; font-style: italic;font-family: 'Lato', Arial, Helvetica, sans-serif;">(.|\n)*?<\/div>/g;
            const found_name = resultData.match(regex_name);
            for(const x in found_name){
              const sp_name = found_name[x].split(' - ');
              let text_name = '';
              for(let i = 0; i < sp_name.length; i++){
                  if(i == (sp_name.length-1)){
                      text_name += '</p></div>';
                  }else{
                      text_name += sp_name[i];
                  }
                  resultData = resultData.replace(found_name[x],text_name); 
              }
            }
            let found2_name;
            if(!found_name){
              const regex2_name = /<div style="font-size:12px;line-height:14px;color:#FFF;font-family:\'Lato\', Tahoma, Verdana, Segoe, sans-serif;text-align:center;"><p style="margin: 0;font-size: 14px;line-height: 17px">(.|\n)*?<\/p><\/div>/g;
              found2_name = resultData.match(regex2_name);
              for(const x in found2_name){
                  const sp_name = found2_name[x].split(' - ');
                  let text_name = '';
                  for(let i = 0; i < sp_name.length; i++){
                      if(i == (sp_name.length-1)){
                          text_name += '</p></div>';
                      }else{
                          text_name += sp_name[i];
                      }
                  }
                  resultData = resultData.replace(found2_name[x],text_name); 
              }
            }
            if(!found_name && !found2_name){
              const regex2_name = /<div class="text-response" style="margin: 24px 3.6rem 0; font-family: \'Lato\', Tahoma, sans-serif; color: #fff; font-size: 14px;">(.|\n)*?<\/div>/g;
              found2_name = resultData.match(regex2_name);
              for(const x in found2_name){
                const sp_name = found2_name[x].split(' - ');
                let text_name = '';
                for(let i = 0; i < sp_name.length; i++){
                    if(i == (sp_name.length-1)){
                        text_name += '</div>';
                    }else{
                        text_name += sp_name[i];
                    }
                }
                resultData = resultData.replace(found2_name[x],text_name); 
              }
            }
            html2pdf(resultData, {
              margin: 1,
              filename: `${this.inforDailyData.file_name}.pdf`,
              html2canvas: { dpi: 192, letterRendering: true, useCORS: true },
              jsPDF: {
                orientation: 'portrait',
                unit: 'cm',
                format: [heightCM, 27.093333333]
              }
            })
            setTimeout(() => {
              this.showSnackbar = false
            }, 5000);
          })
          .catch(error => {
            console.error("error getting file");
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-reports {
  height: 709px;
  background-color: rgba($color: #000000, $alpha: 0.06);
  border-radius: 4px;
}
.line-section {
  margin: 20px 0;
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
}
.image-preview {
  object-fit: cover;
  // max-height: 300px;
}
.mock-email {
  background-color: #f4f4f4;
  border-radius: 6px;
  margin-top: 32px;

  .body-email {
    margin: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .body-email.happiness {
    background-color: #27bc6c;
  }
  .body-email.card {
    background-color: #0f2645;
  }
  .body-email.footer {
    padding: 32px;
    color: #fff;
    font-size: 13px;
    background-color: #071426;
    border-radius: 0 0 6px 6px;
  }
}
.question-card {
  .card-top,
  .card-bottom {
    width: 200px;
    margin: auto;
  }
  .card-top {
    min-height: 60px;
    background: #27bc6c;
    background: linear-gradient(135deg, #008d72 0%, #27bc6c 100%);
    color: #fff;
    text-align: left;
    padding: 14px 18px;
    font-weight: 700;
    line-height: 20px;
    font-size: 15px;
    border-radius: 12px 12px 0 0;
  }
  .card-bottom {
    background-color: #fff;
    padding: 14px 18px;
    font-weight: 700;
    line-height: 20px;
    font-size: 15px;
    border-radius: 0 0 12px 12px;
    margin-bottom: 10px;
    .status-point {
      width: 12px;
      height: 12px;
      border-radius: 12px;
    }
    .status-point.green {
      background-color: #27bc6c;
    }
    .status-point.yellow {
      background-color: #ffba0d;
    }
    .status-point.red {
      background-color: #fe003b;
    }
  }
}
.feeling-status {
  background-color: #3b3b3b;
  border-radius: 12px;
  padding: 30px 32px 15px;
  width: 380px;
  margin: auto;
}
.focus-team {
  background-color: #535353;
  padding-top: 2px;
  padding-bottom: 2px;
}
.day-label {
  width: 31px;
  font-size: 11px;
  color: #b9b9b9;
  margin-top: 2px;
}
.day-label.focus-day {
  font-weight: 700;
  color: #fff;
}
#dailyReports {
  .status {
    margin-right: 8px;
    width: 26px;
    height: 26px;
    border-radius: 26px;
    background-color: #939393;
  }
  .status.plus {
    position: relative;
    &::before {
      content: "+";
      position: absolute;
      color: #b9b9b9;
      font-size: 20px;
      right: -23px;
      top: 3px;
    }
  }
  .status.green {
    background-color: #27bc6c;
  }
  .status.yellow {
    background-color: #ffba0d;
  }
  .status.red {
    background-color: #f22f3c;
  }
  .status {
    width: 16px;
    height: 16px;
    border-radius: 16px;
  }
  .status-gray {
    background-color: #dbdbdb;
  }
  .status-red {
    background-color: #f44336;
  }
  .status-green {
    background-color: #66bb6a;
  }
  .status-yellow {
    background-color: #ffba0d;
  }
  .el-cascader-node__label {
    font-size: 18px;
  }
}
.demomode-warning {
  border: #f5184c solid 2px;
  border-radius: 3px;
  background-color: #f72d3d;
  color: #ffffff;
  font-size: 13px;
  font-family: "Roboto";
  font-weight: 500;
  padding: 9px 15px;
  margin: 27px 0px 13px;
  opacity: 0.8;
}
</style>